import { NgIf, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";

@Component({
  selector: "app-table-placeholder",
  templateUrl: "./table-placeholder.component.html",
  styleUrls: ["./table-placeholder.component.scss"],
  standalone: true,
  imports: [NgIf, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TablePlaceholderComponent {
  @Input() text = "";
  @Input() htmlTextTemplate?: TemplateRef<unknown>;
}
